module.exports = __webpack_public_path__ + "img/filtro-stato-emt.a962564d.png";